// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ns-icons[data-v-356f1bc1]{color:#585858}.ns-icon-small[data-v-356f1bc1]{font-size:14px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
